import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './SalesUploadFolder.css';

const SALES_ROOT = process.env.REACT_APP_SALES_START_PATH || '/sales';

function SalesUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={SALES_ROOT}
      sessionPrefix="sales_folder"
    />
  );
}

SalesUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default SalesUploadFolder;
